import React from "react"
import { Beaker, HeartPulse, Microscope, Activity, Layers, Pill, Brain, Stethoscope, Cpu, Sparkles } from "lucide-react"
import { PhotoPlaceholder } from "../photo-placeholder"

export function ThemesSection() {
  return (
    <div className="grid gap-8 md:grid-cols-3">
      {/* Left content */}
      <div className="md:col-span-2 space-y-6">
        {/* Header */}
        <h2 className="text-3xl font-semibold text-black flex items-center gap-2">
          <Sparkles className="w-6 h-6 text-black" />
          Major Themes
        </h2>

        {/* Theme list */}
        <ul className="grid gap-3 text-sm text-gray-700">
          <li className="flex items-center gap-2">
            <Beaker className="w-4 h-4 text-blue-500" /> Biomaterials design, synthesis &amp; characterization
          </li>
          <li className="flex items-center gap-2">
            <Microscope className="w-4 h-4 text-blue-500" /> Nanomaterials &amp; nanotechnology in healthcare
          </li>
          <li className="flex items-center gap-2">
            <HeartPulse className="w-4 h-4 text-blue-500" /> Tissue engineering &amp; regenerative medicine
          </li>
          <li className="flex items-center gap-2">
            <Pill className="w-4 h-4 text-blue-500" /> Drug delivery &amp; therapeutic systems
          </li>
          <li className="flex items-center gap-2">
            <Layers className="w-4 h-4 text-blue-500" /> Biosystems and biointerfaces
          </li>
          <li className="flex items-center gap-2">
            <Stethoscope className="w-4 h-4 text-blue-500" /> Medical devices &amp; diagnostics
          </li>
          <li className="flex items-center gap-2">
            <Activity className="w-4 h-4 text-blue-500" /> Biomechanics &amp; Rehabilitation Engineering
          </li>
          <li className="flex items-center gap-2">
            <Brain className="w-4 h-4 text-blue-500" /> Biomedical Imaging &amp; Signal Processing
          </li>
          <li className="flex items-center gap-2">
            <Cpu className="w-4 h-4 text-blue-500" /> Computational Modeling &amp; Simulation
          </li>
          <li className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-blue-500" /> AI-Healthcare, Wellness, Ayurveda, Pharmaceuticals, Therapeutics
          </li>
        </ul>

        {/* Subsection card */}
        <div className="rounded-xl border border-blue-200 bg-blue-50/40 p-5 hover:shadow-md transition-all duration-300">
          <h3 className="font-semibold text-blue-600 flex items-center gap-2 mb-2">
            <Stethoscope className="w-5 h-5" />
            Orthopaedics &amp; Clinical
          </h3>
          <ul className="text-sm text-gray-700 grid gap-1.5">
            <li>• Innovations in orthopaedic biomechanics</li>
            <li>• Prosthetic &amp; orthotic device design and evaluation</li>
            <li>• Clinical research &amp; rehabilitation outcomes</li>
            <li>• Biomechanics and gait analysis</li>
            <li>• Arthroplasty, Arthroscopy, Trauma, Spine, Paediatric &amp; Sports Orthopaedics</li>
          </ul>
        </div>
      </div>

      {/* Right image / placeholder */}
      {/* <div className="flex items-center justify-center">
        <div className="w-full rounded-2xl border border-blue-200 bg-gradient-to-br from-blue-50 to-blue-100 p-4 shadow-sm">
          <PhotoPlaceholder label="Theme illustrations or lab photos (add later)" />
        </div>
      </div> */}
    </div>
  )
}
